module.exports = __webpack_public_path__ + "img/carga-header.648c7bd9.png";